import { createAsyncThunk } from '@reduxjs/toolkit';
import { PaginationType } from '../../types/utils/pagination.type';
import { RouteParamsType } from '../../types/utils/router-params.type';
import { ServiceOrderType } from '../../types/service-order/service-order.type';
import { SiteSurveyOutcomeResponseType } from '../../types/service-order/site-survey-outcome.type';
import { additionalQueryParams } from '../../utils/utilities';
import axios from 'axios';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';

export const getServiceOrdersList = createAsyncThunk<
  PaginationType<ServiceOrderType>,
  RouteParamsType & { controller?: AbortController },
  { state: RootReducerState }
>('tcServiceOrders/getList', async (data, thunkAPI) => {
  const { controller, ...params } = data;
  try {
    const additional = additionalQueryParams(
      thunkAPI.getState().sharedReducer.selectedCompany,
      null,
      thunkAPI.getState().sharedReducer.includeSuborgs,
      null
    );
    const mergedParams = { ...params, ...additional };
    const queryString = Object.keys(mergedParams)
      .map(key => key + '=' + mergedParams[key])
      .join('&');

    const response = await axios.get<PaginationType<ServiceOrderType>>(
      `${process.env.REACT_APP_API_URL}/telcobill/service-order${queryString ? `?${queryString}` : ''}`,
      controller ? { signal: controller.signal } : undefined
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error fetching service orders' });
  }
});

export const postSiteSurveyOutcome = createAsyncThunk<
  SiteSurveyOutcomeResponseType,
  { serviceOrderId: number; linesFound: boolean },
  { state: RootReducerState }
>('tcServiceOrders/postSiteSurveyOutcome', async ({ serviceOrderId, linesFound }, thunkAPI) => {
  try {
    const response = await axios.post<SiteSurveyOutcomeResponseType>(
      `${process.env.REACT_APP_API_URL}/telcobill/service-order/${serviceOrderId}/site-survey-outcome`,
      { linesFound }
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error recording the survey outcome' });
  }
});
